import type { FC } from "react"
import React from "react"

import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { DEVICE } from "~/constants/device-widths"
import { useResetZoomAndPan } from "~/hooks/useResetZoomAndPan"

import { CompassRose } from "./CompassRose"
import { ResetLocationButton } from "./ResetLocationButton"
import StreetViewButton from "./StreetViewButton"
import { useDesignerCapabilities } from "../../designer-capabilities"
import { nodeIndex } from "../../state/elements"
import { useZoomToImageCenterPoint } from "../../state/elements/transactions/zoomToImageCenterPoint"
import { phaseState } from "../../state/phase"

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  left: 10px;
  bottom: 120px;
  @media ${DEVICE.laptop} {
    bottom: unset;
  }
  margin-top: 30px;
  z-index: var(--z-toolbar);
`

const IconBar_Internal: FC = () => {
  const zoomToImageCenterPoint = useZoomToImageCenterPoint()
  const resetZoomAndPan = useResetZoomAndPan()
  const nodeIds = useRecoilValue(nodeIndex)
  const phase = useRecoilValue(phaseState)
  const { resetLocation } = useDesignerCapabilities()

  const zoomIn = () =>
    zoomToImageCenterPoint((zoom) => Math.min((11 / 10) * zoom, 1300))
  const zoomOut = () =>
    zoomToImageCenterPoint((zoom) => Math.max((10 / 11) * zoom, 0.1))

  return (
    <Wrapper>
      <CompassRose zoomIn={zoomIn} zoomOut={zoomOut} reset={resetZoomAndPan} />
      <StreetViewButton />
      {resetLocation && !nodeIds.length && phase === `Image Selection` && (
        <ResetLocationButton />
      )}
    </Wrapper>
  )
}

export const IconBar = React.memo(IconBar_Internal)

export default IconBar
